import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { getValue } from "../../../../utils/common";
import { GetActionTitle } from "../Master.constants";

function StateDetails({ action, record : data, onClose }: any) {
    const [stateDetails, setStateDetails] = useState<any>({ hideButtons: true });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'State Name',
                content: getValue(data, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'code',
                label: 'State Code',
                styleClass: 'text-uppercase',
                content: getValue(data, 'code')

            }
        ],
    };

    useEffect(() => {
        if (data) {
            setStateDetails({
                ...stateDetails, ...data
            });
        }
    }, [data]);

    return (
        <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
            <Modal.Header closeButton={true} onHide={onClose}>
                <Modal.Title className="bg">{GetActionTitle('State', action)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormRenderer FormTemplate={FormTemplate}
                    initialValues={{ hideButtons: true, ...data }}
                    componentMapper={ComponentMapper}
                    schema={schema}
                />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                {
                    <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>

                }
            </Modal.Footer>
        </Modal>
    )
}

export default StateDetails;
